/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Calendar_Google_SubInputs */



/**
* | output |
* | --- |
* | "Google Calendar" |
*
* @param {Onboarding_Calendar_Google_SubInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_calendar_google_sub = /** @type {((inputs?: Onboarding_Calendar_Google_SubInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Calendar_Google_SubInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Google Agenda")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Google Agenda")
	return /** @type {LocalizedString} */ ("Google Calendar")
});